export const CONTENT_PAGES = {
  /*
   * STAGE 8D — Useful Educational Content
   *
   * These pages are informational/educational SEO resources.
   * They are intentionally separate from seoContent.js, which
   * contains category-specific topic data.
   *
   * New content pages should be added here first.
   * Routes, sitemap and prerender are registered separately
   * after the content has been audited.
   */

  'kaip-mokyti-vaika-mokytis': {
    slug: 'kaip-mokyti-vaika-mokytis',

    eyebrow: 'TĖVAMS IR PEDAGOGAMS',

    title:
      'Kaip mokyti vaiką mokytis: praktiniai patarimai tėvams | SmartPanda',

    description:
      'Sužinokite, kaip padėti vaikui mokytis namuose: kaip pasirinkti užduotis, palaikyti dėmesį, mokytis žaidžiant ir formuoti gerus mokymosi įpročius.',

    canonical:
      '/mokymosi-gidai/kaip-mokyti-vaika-mokytis',

    h1:
      'Kaip mokyti vaiką mokytis: praktiniai patarimai tėvams',

    intro:
      'Vaikui mokytis lengviau, kai užduotys atitinka jo amžių, gebėjimus ir dėmesio trukmę. Mokymasis nebūtinai turi būti ilgas ar varginantis – trumpa, aiški ir interaktyvi veikla gali padėti vaikui išlaikyti susidomėjimą ir nuosekliai praktikuoti naujus įgūdžius.',

    about: [
      'vaikų mokymasis',
      'mokymosi įpročiai',
      'mokymasis žaidžiant',
      'vaikų edukacija',
    ],

    learningOutcomes: [
      'mokymosi įpročių formavimą',
      'dėmesio išlaikymą',
      'savarankišką mokymąsi',
      'mokymąsi per praktinę veiklą',
    ],

    contentSections: [
      {
        heading: 'Kodėl vaikams svarbu mokytis per veiklą?',
        paragraphs: [
          'Vaikas geriau įsitraukia tada, kai mokymasis nėra vien pasyvus informacijos klausymas ar skaitymas. Praktinės užduotys leidžia vaikui iš karto pritaikyti tai, ką jis mokosi, pamatyti rezultatą ir suprasti, kur dar reikia pasipraktikuoti.',
          'Interaktyvios užduotys taip pat suteikia galimybę mokymąsi suskaidyti į mažesnius žingsnius. Tai ypač naudinga tada, kai nauja tema vaikui atrodo sudėtinga.',
        ],
      },
      {
        heading: 'Kaip pasirinkti tinkamas mokymosi užduotis?',
        paragraphs: [
          'Renkantis užduotis verta atsižvelgti ne tik į vaiko amžių, bet ir į jo dabartinius gebėjimus. Per lengva užduotis gali greitai pabosti, o per sudėtinga gali sumažinti motyvaciją.',
          'Geras pasirinkimas – užduotys, kurias vaikas gali atlikti savarankiškai arba su nedidele suaugusiojo pagalba. Sudėtingumą galima palaipsniui didinti vaikui įgyjant daugiau pasitikėjimo.',
        ],
      },
      {
        heading: 'Mokymasis trumpais etapais',
        paragraphs: [
          'Vaikams dažnai lengviau susikaupti trumpesniam mokymosi etapui nei ilgai trunkančiai veiklai. Todėl galima planuoti kelias trumpas užduotis vietoje vienos ilgos mokymosi sesijos.',
          'Svarbu stebėti patį vaiką: jei jis pavargsta, pradeda skubėti ar nebesidomi užduotimi, verta padaryti pertrauką ir prie mokymosi grįžti vėliau.',
        ],
      },
      {
        heading: 'Mokymasis žaidžiant',
        paragraphs: [
          'Žaidybinis formatas gali padėti mokymosi užduotį pateikti vaikui patrauklesniu būdu. Taškai, pasirinkimai, vizualus grįžtamasis ryšys ir aiškus tikslas gali paskatinti vaiką atlikti daugiau praktinių užduočių.',
          'Svarbu, kad žaidimo elementai papildytų mokymąsi, o ne jį pakeistų. Pagrindinis tikslas išlieka konkretus mokymosi įgūdis.',
        ],
      },
      {
        heading: 'Kaip tėvai gali padėti vaikui?',
        paragraphs: [
          'Tėvams nebūtina nuolat aiškinti kiekvienos užduoties. Dažnai naudingiau užduoti vaikui klausimą, paskatinti jį pačiam pagalvoti ir leisti išbandyti kelis sprendimo būdus.',
          'Reguliarus, ramus ir pozityvus grįžtamasis ryšys padeda vaikui suprasti, kad klaidos yra natūrali mokymosi proceso dalis.',
        ],
      },
    ],

    faq: [
      {
        question: 'Kiek laiko vaikas turėtų mokytis namuose?',
        answer:
          'Vieno tinkamo laiko visiems vaikams nėra. Mokymosi trukmę verta pritaikyti pagal vaiko amžių, dėmesio trukmę, užduoties sudėtingumą ir savijautą. Dažnai geriau keli trumpesni mokymosi etapai nei viena labai ilga sesija.',
      },
      {
        question: 'Ar mokymasis žaidžiant gali būti naudingas?',
        answer:
          'Taip. Tinkamai parinkti mokomieji žaidimai leidžia vaikui praktikuoti konkretų įgūdį interaktyvioje aplinkoje ir gauti greitą grįžtamąjį ryšį.',
      },
      {
        question: 'Kaip paskatinti vaiką mokytis?',
        answer:
          'Padeda aiškus tikslas, tinkamo sudėtingumo užduotys, trumpi mokymosi etapai ir pozityvus grįžtamasis ryšys. Taip pat verta leisti vaikui pasirinkti iš kelių tinkamų užduočių.',
      },
    ],

    gamesHeading: 'Mokomieji žaidimai mokymuisi',
    games: [
      {
        slug: 'figuru-rusiavimas',
        label: 'Figūrų rūšiavimas',
      },
      {
        slug: 'sekos-kurimas',
        label: 'Sekos kūrimas',
      },
      {
        slug: 'simonas-sako',
        label: 'Simonas Sako',
      },
      {
        slug: 'spalvu-derinimas',
        label: 'Spalvų derinimas',
      },
      {
        slug: 'zodziu-medziokle',
        label: 'Žodžių Medžioklė',
      },
      {
        slug: 'skaiciu-atitikimas',
        label: 'Skaičių atitikimas',
      },
    ],
    relatedLinks: [
      {
        label: 'Mokomieji žaidimai vaikams',
        href: '/mokomieji-zaidimai',
      },
      {
        label: 'Loginio mąstymo žaidimai',
        href: '/loginis-mastymas',
      },
      {
        label: 'Dėmesio lavinimo žaidimai',
        href: '/demesys',
      },
      {
        label: 'Skaitymo žaidimai',
        href: '/skaitymo-zaidimai',
      },
    ],

    accent: '#58CC02',

    breadcrumbName: 'Kaip mokyti vaiką mokytis',

    pageType: 'content',
  },

  'kaip-mokyti-vaika-skaityti': {
    slug: 'kaip-mokyti-vaika-skaityti',
    eyebrow: 'TĖVAMS IR PEDAGOGAMS',
    title: 'Kaip mokyti vaiką skaityti – praktiniai patarimai tėvams | SmartPanda',
    description:
      'Sužinokite, kaip mokyti vaiką skaityti nuo raidžių ir garsų iki pirmųjų žodžių bei teksto supratimo. Praktiniai patarimai ir mokomieji žaidimai.',
    canonical: '/mokymosi-gidai/kaip-mokyti-vaika-skaityti',
    h1: 'Kaip mokyti vaiką skaityti?',
    gamesHeading: 'Mokomieji žaidimai skaitymui',
    intro:
      'Mokytis skaityti vaikui lengviau tada, kai raidės, garsai, skiemenys ir pirmieji žodžiai tampa suprantama bei įdomia veikla. Svarbu mokytis palaipsniui, atsižvelgti į vaiko pasirengimą ir suteikti daug progų praktiškai pritaikyti tai, ką jis išmoko.',
    about: [
      'vaikų skaitymas',
      'skaitymo mokymas',
      'skaitymo įgūdžiai',
      'vaikų kalbos ugdymas',
    ],
    learningOutcomes: [
      'raidžių ir garsų pažinimą',
      'skiemenų ir pirmųjų žodžių skaitymą',
      'skaitymo supratimą',
      'skaitymo sklandumą',
    ],
    contentSections: [
      {
        heading: 'Nuo ko pradėti mokyti vaiką skaityti?',
        paragraphs: [
          'Mokymąsi skaityti verta pradėti nuo pagrindų: vaikas turėtų pastebėti raides, atpažinti jų formas ir palaipsniui susieti raides su garsais. Kasdienės trumpos veiklos dažnai yra naudingesnės už ilgą mokymosi sesiją, ypač kai vaikas dar tik pradeda domėtis rašytine kalba.',
          'Pradžioje galima žaisti su raidėmis, ieškoti konkrečios raidės knygose ar aplinkoje, tarti garsus ir kartu ieškoti žodžių, kurie tuo garsu prasideda. Tokia veikla leidžia skaitymo mokymąsi susieti su tuo, ką vaikas jau pažįsta.',
        ],
      },
      {
        heading: 'Kada vaikas pasirengęs mokytis skaityti?',
        paragraphs: [
          'Vaikai skaitymo įgūdžius pradeda ugdyti skirtingu tempu, todėl nėra vienos tinkamos dienos ar amžiaus, kada visi vaikai turėtų pradėti skaityti. Svarbu stebėti, ar vaikui įdomios raidės, knygos, žodžiai ir garsai bei ar jis gali trumpam susikaupti atliekant paprastą užduotį.',
          'Jeigu užduotis vaikui per sudėtinga, galima žingsnį sumažinti: vietoje viso žodžio atpažinti vieną raidę, vietoje skaitymo perskaityti garsus arba kartu aptarti paveikslėlį ir žodį. Mokymosi tempas turėtų būti pritaikytas vaikui.',
        ],
      },
      {
        heading: 'Raidės ir garsai',
        paragraphs: [
          'Vien raidžių pavadinimų įsiminimo ne visada pakanka. Vaikui svarbu suprasti ryšį tarp raidės ir garso, kurį ji žymi. Todėl mokantis galima kartu tarti garsą, ieškoti tos raidės žodžiuose ir pastebėti, kur žodyje ji yra.',
          'Žaidimai su garsais taip pat gali padėti lavinti fonologinį suvokimą. Pavyzdžiui, galima klausti, kokiu garsu prasideda žodis, ar du žodžiai prasideda tuo pačiu garsu, arba paprašyti vaiko surasti aplinkoje daiktą, kurio pavadinimas prasideda pasirinktu garsu.',
        ],
      },
      {
        heading: 'Skiemenys ir pirmieji žodžiai',
        paragraphs: [
          'Kai vaikas geriau atpažįsta raides ir jų garsus, galima pereiti prie skiemenų bei trumpų žodžių. Žodžio skaidymas į mažesnes dalis gali padėti vaikui suprasti, kaip atskiri garsai ir raidės susijungia į tariamą žodį.',
          'Pradžioje verta rinktis trumpus ir vaikui pažįstamus žodžius. Galima juos perskaityti kartu, sudėti iš atskirų dalių arba ieškoti tokio paties žodžio paveikslėlyje ir tekste. Svarbiausia, kad vaikas ne tik perskaitytų žodį, bet ir suprastų jo reikšmę.',
        ],
      },
      {
        heading: 'Skaitymas su vaiku namuose',
        paragraphs: [
          'Bendras skaitymas yra paprastas būdas kasdien natūraliai ugdyti skaitymo įgūdžius. Suaugusysis gali skaityti dalį teksto, o vaikui pasiūlyti perskaityti pažįstamus žodžius, trumpus sakinius ar antraštes.',
          'Skaitymo metu verta kalbėtis apie istoriją, veikėjus ir naujus žodžius. Klausimai „Kas įvyko?“, „Kodėl taip nutiko?“ ar „Kaip manai, kas bus toliau?“ padeda vaikui ne tik perskaityti tekstą, bet ir jį suprasti.',
        ],
      },
      {
        heading: 'Teksto supratimas',
        paragraphs: [
          'Skaitymas nėra vien gebėjimas teisingai ištarti žodžius. Vaikas taip pat turi suprasti perskaitytą informaciją, susieti ją su ankstesnėmis žiniomis ir pastebėti svarbiausias teksto mintis.',
          'Net ir skaitant labai trumpą tekstą galima užduoti vieną ar du klausimus apie jo turinį. Taip vaikas mokosi sustoti, pagalvoti ir patikrinti, ar tikrai suprato tai, ką perskaitė.',
        ],
      },
      {
        heading: 'Mokymasis skaityti žaidžiant',
        paragraphs: [
          'Žaidybinės užduotys gali padėti vaikui daugiau kartų praktikuoti raides, garsus, skiemenis ir žodžius neperkraunant mokymosi proceso. Aiški užduotis, greitas grįžtamasis ryšys ir nedideli pasiekimai gali palaikyti susidomėjimą.',
          'Svarbu pasirinkti žaidimą pagal konkretų mokymosi tikslą. Vienam vaikui tuo metu labiausiai reikės raidžių ir garsų užduočių, kitam – skiemenų, žodžių atpažinimo, teksto supratimo ar skaitymo sklandumo praktikos.',
        ],
      },
      {
        heading: 'Dažniausios klaidos mokant vaiką skaityti',
        paragraphs: [
          'Viena dažnesnių klaidų – skubėti pereiti prie sudėtingesnių tekstų, kai vaikas dar nėra tvirtai įsisavinęs ankstesnių žingsnių. Taip pat nereikėtų kiekvienos klaidos vertinti kaip nesėkmės. Klaidos suteikia informacijos apie tai, ką vaikui dar reikia pasipraktikuoti.',
          'Kita svarbi klaida – lyginti vaiko skaitymo tempą su kitais vaikais. Daug naudingiau stebėti paties vaiko pažangą ir parinkti tokias užduotis, kurios yra pakankamai sudėtingos, bet vis dar įveikiamos.',
        ],
      },
      {
        heading: 'Mokomųjų žaidimų pasirinkimas skaitymui',
        paragraphs: [
          'Skaitymo mokymąsi galima papildyti skirtingo pobūdžio užduotimis. Raidžių pažinimui tinka abėcėlės užduotys, garsų suvokimui – garso atpažinimo žaidimai, o vėlesniam etapui – skiemenų, žodžių ir teksto supratimo užduotys.',
          'SmartPanda skaitymo žaidimus galima pasirinkti pagal konkretų įgūdį, todėl vaikas gali praktikuoti būtent tą sritį, kuriai šiuo metu reikia daugiausia dėmesio.',
        ],
      },
    ],
    faq: [
      {
        question: 'Nuo kokio amžiaus galima pradėti mokyti vaiką skaityti?',
        answer:
          'Vieno tinkamo amžiaus visiems vaikams nėra. Svarbiau atsižvelgti į vaiko susidomėjimą raidėmis ir garsais, gebėjimą trumpam susikaupti bei pasirengimą mokytis.',
      },
      {
        question: 'Kaip mokyti vaiką skaityti namuose?',
        answer:
          'Padeda trumpos reguliarios veiklos: raidžių ir garsų žaidimai, skiemenų bei trumpų žodžių skaitymas, bendras knygų skaitymas ir pokalbiai apie perskaitytą tekstą.',
      },
      {
        question: 'Ar mokomieji žaidimai gali padėti mokytis skaityti?',
        answer:
          'Taip. Tinkamai parinkti žaidimai suteikia papildomų progų praktikuoti konkrečius skaitymo įgūdžius ir gauti greitą grįžtamąjį ryšį.',
      },
      {
        question: 'Ką daryti, jei vaikui sunku skaityti?',
        answer:
          'Verta sumažinti užduoties sudėtingumą, grįžti prie ankstesnio žingsnio ir daugiau praktikuoti tai, kas vaikui dar neaišku. Svarbu vengti skubėjimo ir lyginimo su kitais vaikais.',
      },
    ],
    relatedLinks: [
      {
        label: 'Skaitymo žaidimai vaikams',
        href: '/skaitymo-zaidimai',
      },
      {
        label: 'Teksto supratimo žaidimai',
        href: '/teksto-supratimas',
      },
      {
        label: 'Mokomieji žaidimai vaikams',
        href: '/mokomieji-zaidimai',
      },
      {
        label: 'Kaip mokyti vaiką mokytis',
        href: '/mokymosi-gidai/kaip-mokyti-vaika-mokytis',
      },
    ],
    games: [
      {
        slug: 'abeceles-nuotykis',
        label: 'Abėcėlės Nuotykis',
      },
      {
        slug: 'skiemenu-rusiuotojas',
        label: 'Skiemenų Rūšiuotojas',
      },
      {
        slug: 'garsu-safari',
        label: 'Garsų Safari',
      },
      {
        slug: 'zodziu-bingo',
        label: 'Žodžių Bingo',
      },
      {
        slug: 'pasaku-kelione',
        label: 'Pasakų Kelionė',
      },
      {
        slug: 'greito-skaitymo-lenktynes',
        label: 'Greito Skaitymo Lenktynės',
      },
    ],
    accent: '#58CC02',
    breadcrumbName: 'Kaip mokyti vaiką skaityti',
    pageType: 'content',
  },

  'kaip-ismokyti-vaika-skaiciuoti': {
    slug: 'kaip-ismokyti-vaika-skaiciuoti',
    eyebrow: 'TĖVAMS IR PEDAGOGAMS',
    title: 'Kaip išmokyti vaiką skaičiuoti – praktiniai patarimai tėvams | SmartPanda',
    description:
      'Sužinokite, kaip išmokyti vaiką skaičiuoti nuo skaičių pažinimo ir kiekio supratimo iki sekų, skaičių tiesės ir paprastų matematinių užduočių. Praktiniai patarimai ir mokomieji žaidimai.',
    canonical: '/mokymosi-gidai/kaip-ismokyti-vaika-skaiciuoti',
    h1: 'Kaip išmokyti vaiką skaičiuoti?',
    gamesHeading: 'Mokomieji žaidimai skaičiavimui',
    intro:
      'Skaičiuoti vaikui lengviau mokytis tada, kai skaičiai siejami su realiais daiktais, kasdienėmis situacijomis ir žaidimu. Pradėti verta nuo skaičių pažinimo bei kiekio supratimo, o vėliau palaipsniui pereiti prie sekų, skaičių tiesės ir matematinių veiksmų.',
    about: [
      'vaikų skaičiavimas',
      'skaičių mokymas',
      'skaičiavimo įgūdžiai',
      'matematikos mokymas vaikams',
    ],
    learningOutcomes: [
      'skaičių ir kiekių susiejimą',
      'skaičiavimą ir skaičių sekas',
      'orientavimąsi skaičių tiesėje',
      'pagrindinių matematinių ryšių supratimą',
    ],
    contentSections: [
      {
        heading: 'Nuo ko pradėti mokyti vaiką skaičiuoti?',
        paragraphs: [
          'Mokymąsi skaičiuoti verta pradėti ne nuo skaičių užrašymo, o nuo kiekio supratimo. Vaikas gali skaičiuoti žaislus, kaladėles, vaisius ar kitus kasdienius daiktus ir mokytis susieti paskutinį suskaičiuotą objektą su bendru jų kiekiu.',
          'Kai vaikas pradeda suprasti, kad skaičius nusako konkretų kiekį, galima kartu mokytis atpažinti skaičių simbolius. Pavyzdžiui, prie trijų daiktų parodyti skaičių 3 ir paprašyti vaiko surasti tiek pat kitų objektų.',
        ],
      },
      {
        heading: 'Skaičius ir kiekis',
        paragraphs: [
          'Svarbus ankstyvojo skaičiavimo įgūdis yra gebėjimas susieti skaičių su kiekiu. Vaikui naudinga matyti, kad skaičius nėra tik simbolis, bet reiškia tam tikrą objektų skaičių.',
          'Tam tinka paprastos kasdienės užduotys: suskaičiuoti lėkštes ant stalo, nustatyti, kiek pieštukų yra dėžutėje arba pridėti vieną daiktą ir paklausti, kiek jų dabar yra. Tokios veiklos leidžia matematinę sąvoką susieti su konkrečiu veiksmu.',
        ],
      },
      {
        heading: 'Skaičiavimas pirmyn ir atgal',
        paragraphs: [
          'Kai vaikas jau atpažįsta pagrindinius skaičius, galima praktikuoti skaičiavimą pirmyn ir atgal. Iš pradžių pakanka nedidelio skaičių intervalo, kuriame vaikas jaučiasi užtikrintai.',
          'Skaičiuoti galima lipant laiptais, dėliojant kaladėles, žaidžiant su automobiliais ar atliekant judesio užduotis. Judėjimas ir konkretūs objektai padeda skaičiavimą paversti prasminga veikla, o ne vien skaičių sekos kartojimu.',
        ],
      },
      {
        heading: 'Skaičių sekos ir dėsningumai',
        paragraphs: [
          'Mokantis skaičiuoti svarbu suprasti, kad skaičiai turi tam tikrą tvarką. Vaikui galima pateikti trumpą seką ir paprašyti pasakyti, kuris skaičius turėtų būti toliau.',
          'Vėliau galima naudoti sudėtingesnes sekas, kuriose reikia pastebėti pasikartojančią taisyklę. Tokios užduotys jungia skaičiavimą su loginiu mąstymu ir padeda vaikui pastebėti ryšius tarp skaičių.',
        ],
      },
      {
        heading: 'Skaičių tiesė ir skaičių palyginimas',
        paragraphs: [
          'Skaičių tiesė padeda vaikui vizualiai suprasti, kaip skaičiai išsidėstę vienas kito atžvilgiu. Joje galima parodyti, kuris skaičius yra didesnis, kuris mažesnis ir kas nutinka judant pirmyn arba atgal.',
          'Pavyzdžiui, galima paprašyti vaiko surasti skaičių 5, o tada pajudėti vienu žingsniu į priekį ir pasakyti, ant kurio skaičiaus jis atsidūrė. Tokia veikla padeda suprasti skaičių ryšius ne tik teoriškai, bet ir vizualiai.',
        ],
      },
      {
        heading: 'Pagrindiniai matematiniai veiksmai',
        paragraphs: [
          'Kai skaičių ir kiekių ryšys jau aiškesnis, galima palaipsniui pradėti mokytis sudėties ir atimties. Pradžioje verta naudoti konkrečius objektus, kad vaikas galėtų matyti, ką reiškia pridėti arba paimti kelis daiktus.',
          'Svarbu neapsiriboti vien atsakymo įsiminimu. Vaikui naudinga paaiškinti, ką jis daro: kiek objektų buvo pradžioje, kiek pridėta arba nuimta ir kiek jų liko. Taip matematinis veiksmas tampa suprantamu procesu.',
        ],
      },
      {
        heading: 'Skaičiavimas kasdienėse situacijose',
        paragraphs: [
          'Matematika vaikui tampa prasmingesnė, kai skaičiai naudojami realiose situacijose. Galima kartu skaičiuoti pirkinius, dalyti užkandžius, matuoti ingredientus, planuoti laiką arba nustatyti, kiek daiktų reikia konkrečiai užduočiai.',
          'Tokios situacijos padeda vaikui suprasti, kad skaičiavimas reikalingas ne tik mokantis, bet ir sprendžiant kasdienes problemas. Kuo dažniau vaikas gali pritaikyti skaičius praktiškai, tuo natūralesnis tampa jų naudojimas.',
        ],
      },
      {
        heading: 'Mokymasis skaičiuoti žaidžiant',
        paragraphs: [
          'Žaidybinės užduotys suteikia vaikui daugiau progų kartoti tą patį įgūdį skirtinguose kontekstuose. Skaičių atpažinimą galima derinti su kiekių susiejimu, sekų užduotimis, skaičių tiesės pratimais ir praktinėmis matematikos situacijomis.',
          'Svarbu pasirinkti žaidimą pagal konkretų mokymosi tikslą. Jei vaikui dar sunku atpažinti skaičius, verta pradėti nuo paprastesnių užduočių. Jei pagrindai jau įtvirtinti, galima pereiti prie sudėtingesnių matematinių problemų.',
        ],
      },
      {
        heading: 'Dažniausios klaidos mokant vaiką skaičiuoti',
        paragraphs: [
          'Viena dažnesnių klaidų – per greitai pereiti nuo skaičių pažinimo prie sudėtingų matematinių veiksmų. Jei vaikas dar nėra tvirtai supratęs kiekio ir skaičiaus ryšio, sudėtingesnės užduotys gali sukelti nereikalingą frustraciją.',
          'Taip pat verta vengti vien mechaninio skaičių kartojimo. Geriau dažnai ir trumpai skaičiuoti realius objektus, lyginti kiekius, tęsti sekas ir spręsti paprastas situacijas. Mokymosi tempas turėtų būti pritaikytas vaiko gebėjimams.',
        ],
      },
    ],
    faq: [
      {
        question: 'Nuo kokio amžiaus galima pradėti mokyti vaiką skaičiuoti?',
        answer:
          'Skaičiavimo pagrindų galima pradėti mokytis tada, kai vaikas domisi kiekiais, skaičiais ir gali įsitraukti į trumpas žaidybines užduotis. Svarbiau vaiko pasirengimas nei konkretus amžius.',
      },
      {
        question: 'Kaip mokyti vaiką skaičiuoti namuose?',
        answer:
          'Naudinga skaičiuoti kasdienius daiktus, lyginti kiekius, tęsti paprastas skaičių sekas, naudoti skaičių tiesę ir įtraukti skaičiavimą į žaidimus bei kasdienes situacijas.',
      },
      {
        question: 'Kaip padėti vaikui suprasti skaičių tiesę?',
        answer:
          'Galima naudoti vizualią skaičių tiesę ir prašyti vaiko surasti skaičių, pajudėti pirmyn arba atgal bei palyginti, kuris skaičius yra didesnis ar mažesnis.',
      },
      {
        question: 'Ar mokomieji žaidimai gali padėti mokytis skaičiuoti?',
        answer:
          'Taip. Tinkamai parinkti žaidimai suteikia papildomų progų praktikuoti skaičių atpažinimą, skaičiavimą, sekas, skaičių tiesę ir matematinių problemų sprendimą.',
      },
    ],
    relatedLinks: [
      {
        label: 'Skaičių ir skaičiavimo žaidimai',
        href: '/skaiciai-ir-skaiciavimas',
      },
      {
        label: 'Matematikos žaidimai vaikams',
        href: '/matematikos-zaidimai',
      },
      {
        label: 'Mokomieji žaidimai vaikams',
        href: '/mokomieji-zaidimai',
      },
      {
        label: 'Kaip mokyti vaiką mokytis',
        href: '/mokymosi-gidai/kaip-mokyti-vaika-mokytis',
      },
      {
        label: 'Kaip mokyti vaiką skaityti',
        href: '/mokymosi-gidai/kaip-mokyti-vaika-skaityti',
      },
    ],
    games: [
      {
        slug: 'skaiciu-atitikimas',
        label: 'Skaičių atitikimas',
      },
      {
        slug: 'sokinejimas-ant-skaiciu-tieses',
        label: 'Šokinėjimas ant skaičių tiesės',
      },
      {
        slug: 'matematikos-bingo',
        label: 'Matematikos Bingo',
      },
      {
        slug: 'pinigine-parduotuve',
        label: 'Pinigų Parduotuvė',
      },
      {
        slug: 'daugybos-lenktynes',
        label: 'Daugybos Lenktynės',
      },
      {
        slug: 'pasaku-matematika',
        label: 'Pasakų Matematika',
      },
    ],
    accent: '#58CC02',
    breadcrumbName: 'Kaip išmokyti vaiką skaičiuoti',
    pageType: 'content',
  },

};

export const CONTENT_PAGE_LIST = Object.values(CONTENT_PAGES);

export function getContentPage(slug) {
  return CONTENT_PAGES[slug] || null;
}
